function updatePageConfigCart(cartData, modelId) {
  const {
    minPurchaseAmountForCld: applicableCldValue,
    storeCreditsLeft: creditsAvailable,
    saleCampaignActive: isSaleOff,
    itemIds,
    saleOffColor,
    saleOffDiscount,
    saleOffTitle,
    size,
    finalPrice: value,
  } = cartData

  const updatePageConfigCartData = () => {
    window.pageConfig.cart = {
      ...window.pageConfig.cart,
      applicableCldValue,
      creditsAvailable,
      isSaleOff,
      itemIds,
      saleOffColor,
      saleOffDiscount,
      saleOffTitle,
      size,
      value,
    }

    const cartItem = (cartData.trackingCartItems || [])
      .find(item => String(item.id) === String(modelId))

    if (cartItem) {
      window.pageConfig.cart_items.push(cartItem)
    }
  }

  if (window && window.pageConfig) {
    updatePageConfigCartData()
  }
}

export default updatePageConfigCart
